module.exports = __webpack_public_path__ + "img/mtt_3.2.499050a5.png";